import React from "react";
import { Service, Translation } from "rsl-api-106/lib/types";
import { FavoriteEtabType, FavoriteProposalType, Funnel_Type } from "types";

import { getLocalStorageItem } from "@utils/localStorage";

type SessionContextType = {
  sessionId: string | null;
  setSessionId: (session: string | null) => void;
  authMode: number | null;
  partner: Service | null;
  lang: string;
  funnel_type: Funnel_Type;
  languagesVars: Translation[];
  getLanguageVarValue: (code: string) => string;
  setPartner: (partner: Service | null) => void;
  favoriteProposals: FavoriteProposalType[];
  setFavoriteProposals: (favorites: FavoriteProposalType[]) => void;
  favoriteEtabs: FavoriteEtabType[];
  setFavoriteEtabs: (favorites: FavoriteEtabType[]) => void;
};

export const SessionContext = React.createContext<SessionContextType>({
  sessionId: null,
  setSessionId: () => {},
  authMode: null,
  partner: null,
  lang:
    getLocalStorageItem("rsl-lang") ??
    process.env.REACT_APP_LANG?.split(",")[0] ??
    "FR",
  funnel_type: "reservation",
  getLanguageVarValue: () => "",
  languagesVars: [],
  setPartner: () => {},
  favoriteProposals: [],
  setFavoriteProposals: () => {},
  favoriteEtabs: [],
  setFavoriteEtabs: () => {},
});
